import { TFunction } from 'i18next';
import { ReCaptchaErrorCode, RecaptchaError, serverCaptchaErrors, userCaptchaErrors } from './recaptcha.service';
import * as Sentry from '@sentry/nextjs';

export function handleReCaptchaError(error: any) {
  const isCaptchaServerError =
    error.errorType === RecaptchaError && error.error.find(code => serverCaptchaErrors.includes(code));
  if (isCaptchaServerError) {
    Sentry.captureException(error);
  }
}

export function extractReCaptchaErrors(error: any, t: TFunction): string[] {
  return (
    error?.errorType === RecaptchaError
      ? error?.error.filter((code: ReCaptchaErrorCode) => userCaptchaErrors.includes(code)) ?? []
      : []
  ).map((code: string) => t(`gobal:reCaptcha.errors.${code}`));
}
